import {
	Component,
	OnInit,
	ChangeDetectorRef,
	AfterViewInit
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { AppUtil } from "../../../utils/app.util";
@Component({
	selector: "app-pickup-method",
	templateUrl: "./pickup-method.component.html",
	styleUrls: ["./pickup-method.component.css"]
})
export class DmvPickupMethodComponent implements OnInit, AfterViewInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		private cd: ChangeDetectorRef
	) {}
	public errorMessage: string = "";
	public isloading: boolean = false;

	ngOnInit() {
		AppUtil.log("DmvPickupMethodComponent ngOnInit() == >");
		if (
			this.globalService.params &&
			this.globalService.params.deliveryMethodID
		) {
			if (this.globalService.params.deliveryMethodID === "1") {
				this.pickup("mailing");
			} else if (this.globalService.params.deliveryMethodID === "2") {
				this.pickup("in-person");
			}
		}

		if (this.globalService.cartNature === "manual") {
			this.pickup("mailing");
		}
	}
	public pickup(type) {
		AppUtil.log("DmvPickupMethodComponent pickup() == >", type);

		if (type === "mailing") {
			if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate ||
				this.dmvStoreService.agencyConfig.agencyDmvConfig
					.allowMailingToTempAddress
			) {
				this.router.navigate(["dmv-pickup-mailing"], {
					skipLocationChange: true
				});
			} else {
				this.dmvStoreService.updateAddress();
				this.router.navigate(["dmv-review-cart"], {
					skipLocationChange: true
				});
			}
		} else if (type === "in-person") {
			this.router.navigate(["dmv-pickup-in-person"], {
				skipLocationChange: true
			});
		}
	}

	public goBack() {
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from &&
			this.dmvStoreService.routeFrom.from !== "dmv-manual-renew" &&
			this.dmvStoreService.routeFrom.from !== "dmv-duplicate"
		) {
			AppUtil.log(
				"DmvPickupMethodComponent goBack() == >",
				this.dmvStoreService.routeFrom
			);

			this.router.navigate([this.dmvStoreService.routeFrom.from], {
				skipLocationChange: true
			});
		} else {
			AppUtil.log("DmvPickupMethodComponent goBack() == > dmv-donation");

			this.router.navigate(["dmv-donation"], { skipLocationChange: true });
		}
	}
	ngAfterViewInit() {}
}
